import md5 from '@/common/libs/md5/md5.js';

export default {
	//替换手机号中间部分为*
	formatMobile(mobile = '') {
		if(mobile == '') {
			return '';
		}
		let mobileStr = mobile.substr(3, 4);
		return mobile.replace(mobileStr, '****');
	},
	
	//用户头像
	getUserHead(head = '') {
		if(!head) {
			return require('@/static/images/avatar.png');
		} else {
			return head.indexOf('data:image') === 0 ? head : (head.indexOf('http') === 0 ? head : this.trim(uni.$sk.config.baseUrl, '/', 'right') + '/' + this.trim(head, '/', 'left'));
		}
	},
	
	showLoading(title = 'Loading...') {
		uni.showLoading({
			title,
			mask: true
		})
	},
	
	trim(str = '', remove = ' ', type = 'all') {
		if(str == '') {
			return '';
		}
		str = str.toString();
		if(type == 'left' || type == 'all') {
			while(str.substr(0, 1) == remove) {
				str = str.substr(1, str.length - 1);
			}
		}
		
		if(type == 'right' || type == 'all') {
			while(str.substr(str.length - 1, 1) == remove) {
				str = str.substr(0, str.length - 1);
			}
		}
		return str;
	},
	
	md5(string) {
		return md5(string.toString());
	},
	
	//客户端秘钥
	getSecret() {
		let clientAgent = this.getClientAgent();
		return this.md5(JSON.stringify(clientAgent));
	},
	
	getClientAgent() {
		const systemInfo = uni.getSystemInfoSync();		
		return {
			browserName: systemInfo.browserName,
			browserVersion: systemInfo.browserVersion,
			deviceBrand: systemInfo.deviceBrand,
			deviceModel: systemInfo.deviceModel,
			devicePixelRatio: systemInfo.devicePixelRatio,
			deviceType: systemInfo.deviceType,
			hostName: systemInfo.hostName,
			hostVersion: systemInfo.hostVersion,
			osName: systemInfo.osName,
			osVersion: systemInfo.osVersion,
			pixelRatio: systemInfo.pixelRatio,
			platform: systemInfo.platform,
			system: systemInfo.system,
			ua: systemInfo.ua,
			uniPlatform: systemInfo.uniPlatform,
		};
	},
	
	jointUrl(url = '', params = {}) {
		let urls = url.split('?');
		url = urls[0];
		let queryParams = urls[1] ? this.trim(urls[1], '&', 'right') : '';
		if(Object.keys(params).length > 0) {
			queryParams += this.object2QueryString(params);
		}
		return `${url}?${queryParams}`;
	},
	
	object2QueryString(object = {}) {
		return Object.keys(object).map(index => {
			return typeof(object[index]) == 'object' ? this.Object2QueryString(object[index]) : `${index}=${object[index]}`;
		}).join('&');
	},
	
	//根据百分比得到具体尺寸
	getScreenPreSize(type = 'width', size = 100) {
		const systemInfo = uni.getSystemInfoSync();
		let typeKey = type == 'width' ? 'screenWidth' : 'screenHeight';
		let preSize = parseInt(size) / 100;
		return systemInfo[typeKey] * preSize;
	},
	
	//安全区域尺寸
	getSafeAreaInsets(position = '') {
		let safeAreaInsets = uni.getSystemInfoSync().safeAreaInsets;
		return position == '' ? safeAreaInsets : safeAreaInsets[position];
	},
	
	//顶部状态栏高度
	getNavbarHeight(navbar = 1) {
		let height = this.getSafeAreaInsets('top');
		if(navbar) {
			height += 44;
		}
		return height;
	},
	
	//底部tabbar高度
	getTabbarHeight(tabbar = 1) {
		let height = this.getSafeAreaInsets('bottom');
		if(tabbar) {
			height += 51;
		}
		return height;
	},
	
	//页面主体区域高度
	getPageHeight(navbar = 1, tabbar = 1) {
		let height = '100vh';
		if(navbar || tabbar) {
			height += ' - (';
			let barHeight = 0;
			if(navbar) {
				barHeight = this.getNavbarHeight(1);
			}
			if(tabbar) {
				barHeight += this.getTabbarHeight(1);
			}
			height += barHeight + 'px)';
		}
		height = 'calc( ' + height + ' )';
		return height;
	},
	
	//判断当前是否h5微信公众号环境
	isWeixin() {



		var ua = window.navigator.userAgent.toLowerCase();
		return ua.match(/micromessenger/i) == 'micromessenger' ? true : false;
	},
	
	//客户端端口
	clientPort() {



	

			return this.isWeixin() ? 'H5-WECHAT' : 'H5';

			



	},
	
	//验证手机号码合法性
	checkMobile(mobile) {
		return /^0?1\d{10}$/.test(mobile);
	},
	
	//验证电子邮箱
	checkEmail(email) {
		return /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[0-9a-zA-Z]{1,}$/
			.test(email);
	},
	
	//得到时间戳
	getTimestamp(dateTime = '', extract = 1) {
		let timestamp = dateTime == '' ? new Date().getTime() : this.strToDate(dateTime).getTime();
		timestamp = extract === 1 ? timestamp.toString().slice(0, 10) : timestamp;
		return Number(timestamp);
	},
	
	strToDate(dateObj) {
		if(isNaN(dateObj)) {
			dateObj = dateObj.replace(/T/g, ' ').replace(/.[d]{3}Z/, '').replace(/(-)/g, '/')
			if (dateObj.indexOf(".") > 0) {
				dateObj = dateObj.slice(0, dateObj.indexOf("."))
			}
		}			
		return new Date(dateObj)
	},
	
	//短信发送签名
	smsSign(mold, mobile, token) {
		let secret = this.getSecret();
		let data = {
			mold, mobile, token, secret
		}
		let sortKey = Object.keys(data).sort();
		let signArr = [];
		for(let k of sortKey) {
			signArr.push(`${k}=${data[k]}`);
		}
		return this.md5(token + signArr.join('&') + token);
	},
	
	getLoginPath() {
		let clientPort = this.clientPort();
		let pagePath;
		switch(clientPort) {
			case 'H5-WECHAT':
				pagePath = '/login/weChatAccount';
				break;
				
			case 'MP-WEIXIN':
				pagePath = '/login/weChatMiniapp';
				break;
			
			case 'H5':
			case 'APP':
				pagePath = '/login/h5';
				break;
		}
		return pagePath;
	},
	
	getweChatMiniappSceneQuery(scene, name) {
		let sceneObj = decodeURIComponent(scene).split('|');
		if(sceneObj.length == 0) {
			return '';
		}
		for(let index in sceneObj) {
			let params = sceneObj[index].split('=');
			if(params[0] === name) {
				return params[1];
			}
		}
		return '';
	},
	
	//空数据图表
	getEmptyIco(type = 'search') {
		/* 
		car	购物车为空
		page	页面不存在
		search	没有搜索结果
		address	没有收货地址
		wifi	没有WiFi
		order	订单为空
		coupon	没有优惠券
		permission	无权限
		history	无历史记录
		news	无新闻列表
		message	消息列表为空
		list	列表为空(通用)
		data	数据为空(默认，通用) 
		 */
		return uni.$sk.func.trim(uni.$sk.config.baseUrl, 'right', '/') + '/static/wapapi/images/empty/' + type + '.png';
	},
	
	//格式化编辑器代码
	formatHtmlImage(html = '') {
		if(html == '') {
			return html;
		}
		const styleRegex = new RegExp('style=""', 'gi');
		html = html.replace(styleRegex, ''); // 加上自己所需要的样式 // 去掉style=""
		const regex = new RegExp('img', 'gi');
		html = html.replace(regex, `img style="max-width:100%;"`) // 加上自己所需要的样式
		return html;
	},
	
	//根据区域大小，自动缩放图片比例
	autoScaleImage(imageUrl, width, height) {
		return new Promise((resolve, reject) => {
			uni.getImageInfo({
				src: imageUrl,
				success(res) {
					let imageWidth =  res.width;
					let imageHeight = res.height;
					if(imageWidth < width && imageHeight < height) {
						//如果原图尺寸小于生成缩略图尺寸，返回原图路径
						return {
							width: imageWidth,
							height: imageHeight
						};
					}
					
					let sx = imageWidth / width;
					let sy = imageHeight / height;
					let s = sx > sy ? sx : sy;
					let newWidth = parseInt(imageWidth / s);
					let newHeight = parseInt(imageHeight / s);
					resolve({
						width: newWidth,
						height: newHeight
					});
				},
				
				fail(err) {
					console.log(err);
					reject(err);
				}
			});
		});
	}
}